<template>
  <div>

    <div class="bar_nav">
      <div class="title">修改密码</div>
      <div class="bar_back_btn" @click="goToUserSetting">我</div>
    </div>
    <div class="bar_empty"></div>

    <div class="form">
      <input class="field" label="" placeholder="请输入新密码" type="password" v-model="password" />
      <div class="btn_large" @click="updatePassword">保存</div>
    </div>
    <!-- <mt-field type="password" v-model="password"></mt-field> -->
    <!-- <div @click="updatePassword">保存</div> -->

  </div>
</template>

<script>
import { Toast } from 'mint-ui'
export default {
  name: 'EditPassword',
  data: function () {
    return {
      password: ''
    }
  },
  async created() {
  },
  methods: {
    async updatePassword() {
      try {
        if (!this.password || this.password.length < 8) {
          return Toast({
            message: '密码不能为空, 且必须至少8位'
          })
        }
        await this.$faApi.updateUserInfo(this.$route.params.userId, {
          password: this.password
        })
        this.$router.push({ path: `/user/${this.$route.params.userId}/user_setting` })
      } catch (err) {
        this.$faLogger.error('EditPassword.vue:updatePassword', err)
      }
    },
    goToUserSetting() {
      this.$router.push({ path: `/user/${this.$route.params.userId}/user_setting` })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
  